/*
 * Proprietary and Confidential
 *
 * Copyright (c) [2018] -  [] Marcelo H. Krebber - Munich, London 2018
 * All Rights Reserved.
 *
 * Dissemination or reproduction of this file [update-account.js] or parts within
 * via any medium is strictly forbidden unless prior written permission is obtained
 * from <marcelo.krebber@gmail.com>
 *
 * Last modified: 03.01.20, 09:01
 */
import React, {Fragment, useEffect} from 'react';
import {useAuthorization} from "../../../selectors";
import {useIsMobile, useLanguage} from "../../configuration/configuration";
import useFetchQRCode from "../../hooks/use-fetch-qrcode";
import {SUCCESS_STATUS} from "../../../actions";
import {Spinner} from "../../util/spinner";
import {QRCode} from "../space/show-qrcode-dialog";
import DialogBox from "../dialog-box";

import {Swiper, SwiperSlide} from 'swiper/react';
import {EffectCards} from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-cards';

// TODO currently displaying only one QR-code - must support multiple QR-codes
const DigitalWallet = ({isOpen, setIsOpen}) => {
    const {isAuthorized, principalUsername} = useAuthorization();
    const {fetchAccountQrCode, qrCode, status} = useFetchQRCode();
    const isMobile = useIsMobile();
    const Lang = useLanguage();

    useEffect(() => {
        isAuthorized && fetchAccountQrCode(principalUsername);
    }, [principalUsername]);

    const getQrCodeSlide = (qrCode) => {
        return <SwiperSlide>
            <div className='digital-card-container-body'>
                <div className='digital-card-container-svg'>
                    <QRCode qrCode={qrCode.svgQrCode}/>
                </div>
                <div className='digital-card-container-text'>
                    <div className='mb-2'>{qrCode.fullname}</div>
                    <div>{Lang.qrcode.update.memberSince} {qrCode.memberSince}</div>
                    <div>{Lang.qrcode.update.validUntil} {`${qrCode.validUntil ? qrCode.validUntil : '-'}`}</div>
                    <div>{qrCode.siteName}</div>
                    <div>{Lang.qrcode.update.web} {qrCode.siteUrl}</div>
                    <div className='digital-card-container-membership mt-1'>
                        {qrCode.membership} {Lang.qrcode.member.membership}
                    </div>
                </div>
            </div>
        </SwiperSlide>
    }

    const getTextSlide = (text) => {
        return <SwiperSlide>
            <div className='digital-card-container-body'>
                <div className='digital-card-container-text'>
                    {text}
                </div>
            </div>
        </SwiperSlide>
    }

    if (isAuthorized && status !== SUCCESS_STATUS) return <Spinner/>

    return <DialogBox title="Dein Digitaler Wallet"
                      action={null}
                      isOpen={isOpen}
                      setIsOpen={setIsOpen}
                      isDisabled={!isAuthorized}
                      cancelButton = {!isMobile}
                      callback={null}>
        <div className="digital-wallet-container">
            <Swiper
                effect={'cards'}
                grabCursor={true}
                modules={[EffectCards]}
                className=""
            >
                {isAuthorized && <>
                    {getQrCodeSlide(qrCode)}
                    {getTextSlide("Das war alles. Keine weiteren QR-Codes in Deinem Wallet.")}
                </>}

                {!isAuthorized && <>
                    {getTextSlide("Bitte einloggen um Dein Digitaler Wallet anzuzeigen.")}
                    {getTextSlide("Mit einer Mitgliederkarte erhälst viele Vorteile. " +
                        "Und bekommst Zugang zu geschützten Inhalte und Funktionen.")}
                </>}
            </Swiper>
        </div>
    </DialogBox>
};

export default DigitalWallet;

